export default "__VITE_ASSET__Dy9AI4n5__"